import React from 'react';

export default function PillGroup({ value, onChange, options, modoOscuro, className = '' }) {
  return (
    <div
      className={`inline-flex flex-wrap items-center rounded-lg border p-0.5 ${
        modoOscuro ? 'border-gray-700 bg-gray-800/80' : 'border-gray-200 bg-gray-50'
      } ${className}`}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            className={`px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors ${
              active
                ? 'bg-[#1F80FF] text-white'
                : modoOscuro
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
